// extracted by mini-css-extract-plugin
export default {"card-container":"styles_card-container__vvx9S px-3 py-4","error-message-tip":"styles_error-message-tip__5Oq4n"};